export default {
  label: {
    description: 'Comparado a ',
  },
};
